import { quickProperty, designToken } from '../component-tokens';
import { borderBase } from './common';
export const contextualActionTokens = {
    name: 'contextual-action',
    tag: 'chameleon-contextual-actions',
    reactImports: 'ContextualActions, ContextualActionSeparator',
    attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('surface-color-default'), 'box-shadow': designToken('elevation-medium'), 'border-color': designToken('border-color-default'), 'border-radius': designToken('radius-small'), display: quickProperty('inline-flex'), padding: quickProperty('0 0.25rem') }),
    children: [
        {
            name: 'button',
            attributes: {
                margin: quickProperty('3px 0.25rem 3px 0'),
            },
        },
        {
            name: 'separator',
            attributes: {
                width: quickProperty('1px'),
                'border-right': quickProperty('1px solid'),
                'border-color': designToken('border-color-default'),
                'margin-right': quickProperty('0.25rem'),
            },
        },
    ],
    variants: [
        {
            name: 'transparent',
            attributes: {
                'background-color': quickProperty('transparent'),
                border: quickProperty('none'),
                'box-shadow': quickProperty('none'),
            },
            children: [
                {
                    name: 'button',
                    attributes: {
                        'background-color': designToken('interactive-color-secondary-default'),
                        'border-radius': designToken('radius-small'),
                    },
                },
            ],
        },
    ],
};
